var exports = {
  "zr": "x620889e6--bdee96--root",
  "PQ": "x620889e6--bdee96--border",
  "Lw": "x620889e6--bdee96--overlay",
  "DD": "x620889e6--bdee96--title",
  "YL": "x620889e6--bdee96--tooltip",
  "hr": "x620889e6--bdee96--tooltip-body",
  "Vt": "x620889e6--bdee96--prices",
  "x6": "x620889e6--bdee96--button",
  "Sl": "x620889e6--bdee96--image",
};

module.exports = exports;
